<template>
  <div class="page-container">
    <van-nav-bar
      :left-arrow="leftArrow"
      @click-left="goHome"
      fixed
      title="支付结果查询中..." />
    <div class="page">
      <div style="margin-top: 30vw">
        <div class="load8">
          <div class="loader"></div>
          <div class="text">{{ time }}</div>
        </div>
        <div class="ta-c fs-18 color-dark mt-30">正在等待对方返回结果...</div>
        <div class="ta-c fs-14 color-red mt-10">返回结果前,请勿重复提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Toast } from "vant"
import * as OrderApi from "@/api/order"
export default {
  name: "wait",
  data: () => ({
    time: 10,
    si: null,
    leftArrow: false,
    orderNo: ""
  }),
  mounted() {
    this.orderNo = this.$route.query.order_no
    this.sync()
    this.run()
  },
  methods: {
    run() {
      this.si = setInterval(() => {
        if (this.time === 0) {
          clearInterval(this.si)
          this.leftArrow = true
        } else {
          this.time--
        }
      }, 1000)
    },
    goHome() {
      this.$router.replace("/user?chanlCode=TA")
    },
    sync() {
      const that = this
      OrderApi.syncOrderById(this.orderNo)
        .then((data) => {
          if ("SUCCESS" == data.result) {
            this.successRedirect(that, data)
          } else if ("FAILURE" == data.result) {
            //展示失败的试图
            this.failueRedirect(that, data)
          } else {
            //nothing todo
          }
        })
        .catch((ex) => {
          console.log("订单同步异常:%O", ex)
        })
    },
    failueRedirect(that, data) {
      if (data.type == "1") {
        Toast({
          message: "认购失败",
          duration: 1500,
          onClose() {
            //展示成功的视图
            that.$router.replace({
              path: "/user",
              query: { chanlCode: "TA" }
            })
          }
        })
      } else if (data.type == "2") {
        Toast({
          message: "充值失败",
          duration: 1500,
          onClose() {
            //展示成功的视图
            that.$router.replace({
              path: "/user",
              query: { chanlCode: "TA" }
            })
          }
        })
      }
    },
    successRedirect(that, data) {
      if (data.type == "1") {
        Toast({
          message: "认购成功",
          duration: 1500,
          onClose() {
            //展示成功的视图
            that.$router.replace({
              path: "/paysuccess",
              query: {
                investId: data.investId,
                productType: 1
              }
            })
          }
        })
      } else if (data.type == "2") {
        Toast({
          message: "充值成功",
          duration: 1500,
          onClose() {
            //展示成功的视图
            that.$router.replace({
              path: "/user",
              query: { chanlCode: "TA" }
            })
          }
        })
      }
    }
  },
  components: {
    [NavBar.name]: NavBar
  }
}
</script>

<style lang="less" scoped>
.load8 {
  position: relative;
  .text {
    position: absolute;
    font-size: 48px;
    color: @red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 25vw;
    height: 25vw;
    margin: 0 auto;
  }

  .loader {
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid fade(@dark, 20%);
    border-right: 1.1em solid fade(@dark, 20%);
    border-bottom: 1.1em solid fade(@dark, 20%);
    border-left: 1.1em solid fade(@dark, 100%);
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>